import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiConstants } from '../Constants/api.constant.js';
import { candidatesActions } from '../Services/candidates.service.js';
import { toast } from 'react-hot-toast'


export const searchAllCandidates = createAsyncThunk('candiadte/getAllCandidate', async (data) => {
  const response = await candidatesActions.searchAllCandidates(apiConstants.SEARCH_ALL_CANDIDATE, data);
  if(response && response.status){
    // toast.success(response.message, {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  }else{
    // toast.error(
    //   response.message, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   }
    // )
  }
  return response;
});

export const getCandidateById = createAsyncThunk('candidate/getCandidateById', async (data) => {
    const response = await candidatesActions.getCandidateById(apiConstants.GET_CANDIDATE_BY_ID, data);
    if(response && response.status){
      // toast.success(response.message, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
    }else{
      // toast.error(
      //   response.message, {
      //     position: toast.POSITION.TOP_RIGHT,
      //   }
      // )
    }
    return response;
});

export const candidateTestLogs = createAsyncThunk('candidateTestLogs', async (data) => {
  const response = await candidatesActions.candidateTestLogs(apiConstants.CANDIDATE_TEST_LOGS,data); 
  return response; 
});

export const bulkDeleteCandidate = createAsyncThunk('bulkDeleteCandidate', async (data) => {
  const response = await candidatesActions.bulkDelete(apiConstants.BULK_DELETE_CANDIDATE, data); 
  if(response && response.status){
    toast.success(response.message)
  }else{
    toast.error(response.message)
  }
});
export const testReportOverride=createAsyncThunk('testReportOverride',async(data)=>{
  const response=await candidatesActions.testReportOverride(apiConstants.TEST_REPORT_OVERRIDE,data);
  if(response && response.status){
    toast.success(response.message)
  }else{
    toast.error(response.message)
  }
})

const candidatesSlice = createSlice({
  name: 'candidates',
  initialState: {
    loading: false,
    error: null,
    getAllCandidates: null,
    getCandidateById: null,
    candidateTestLogsData: null,
    bulkDeleteCandidate: null
  },
  reducers: {
    candidatesValue: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchAllCandidates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchAllCandidates.fulfilled, (state, action) => {
        state.loading = false;
        state.getAllCandidates = action.payload;
      })
      .addCase(searchAllCandidates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getCandidateById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.getCandidateById = null;
      })
      .addCase(getCandidateById.fulfilled, (state, action) => {
        state.loading = false;
        state.getCandidateById = action.payload;
      })
      .addCase(getCandidateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(candidateTestLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.candidateTestLogsData = null;
      })
      .addCase(candidateTestLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.candidateTestLogsData = action.payload;
      })
      .addCase(candidateTestLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(bulkDeleteCandidate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkDeleteCandidate.fulfilled, (state, action) => {
        state.loading = false;
        state.bulkDeleteCandidate = action.payload;
      })
      .addCase(bulkDeleteCandidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  
  },
});


export const { candidatesValue } = candidatesSlice.actions;
export default candidatesSlice.reducer 